import React from 'react';
import { Box, Typography, Stack, Button, IconButton } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import {
  CONTENT_BLOCK_HEIGHT,
  externalFlowContentColumnSx,
  externalFlowGlassCardLayoutSx,
  externalFlowInCardBrandingSx,
  externalFlowLineClamp3Sx,
  externalFlowPrimaryButtonSx,
  externalFlowSuccessIconInnerWellSx,
  externalFlowSuccessRingContainerSx,
  externalFlowSuccessRingSpinBackdropSx,
  LABEL_PRIMARY,
  LABEL_SECONDARY,
  LETTER_SPACING,
  SUBTITLE_FONT_SIZE,
  TITLE_FONT_SIZE,
  UPLOAD_FLOW_PAGE_BG,
} from './uploadCardLayout';
import { ReactComponent as UploadCompleteIcon } from '../../Assets/upload-complete.svg';

const DoneCard = ({ onOpenGallery, onTryAgain }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 0,
        flexShrink: 0,
        bgcolor: UPLOAD_FLOW_PAGE_BG,
        width: '100%',
      }}
    >
      <Box
        sx={{
          ...externalFlowContentColumnSx,
          minHeight: CONTENT_BLOCK_HEIGHT,
          maxHeight: CONTENT_BLOCK_HEIGHT,
        }}
      >
        <Box sx={{ ...externalFlowGlassCardLayoutSx }}>
          <Box
            aria-hidden="true"
            sx={{
              position: 'absolute',
              inset: 0,
              backgroundImage: "url('/assets/floorplan-bg.png')",
              backgroundSize: 'cover',
              backgroundPosition: '80% 20%',
              transform: 'scale(1.08) scaleX(-1)',
              zIndex: 0,
              pointerEvents: 'none',
            }}
          />

          <Box
            aria-hidden="true"
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(160deg, rgba(245,245,247,0.72) 0%, rgba(200,200,210,0.88) 100%)',
              zIndex: 1,
              pointerEvents: 'none',
            }}
          />

          {onTryAgain && (
            <IconButton
              onClick={onTryAgain}
              size="small"
              aria-label="Upload another floor plan"
              sx={{
                position: 'absolute',
                top: 12,
                left: 12,
                zIndex: 4,
                color: LABEL_SECONDARY,
                padding: '5px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.06)',
                  color: LABEL_PRIMARY,
                },
              }}
            >
              <ReplayIcon sx={{ fontSize: 18 }} />
            </IconButton>
          )}

          <Stack
            spacing={0}
            alignItems="center"
            sx={{
              width: '100%',
              height: '100%',
              position: 'relative',
              zIndex: 3,
              pt: '30px',
              pb: 0,
            }}
          >
            <Box sx={{ flex: 1, minHeight: 0 }} />

            <Box
              sx={{
                ...externalFlowSuccessRingContainerSx,
                width: 40,
                height: 40,
                minWidth: 40,
                minHeight: 40,
                mb: '8px',
              }}
            >
              <Box sx={externalFlowSuccessRingSpinBackdropSx} />
              <Box
                sx={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1,
                  width: 36,
                  height: 36,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box sx={externalFlowSuccessIconInnerWellSx}>
                  <UploadCompleteIcon
                    style={{
                      width: 22,
                      height: 22,
                      filter: 'drop-shadow(0 1px 4px rgba(0, 0, 0, 0.3))',
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: LABEL_PRIMARY,
                fontSize: TITLE_FONT_SIZE,
                letterSpacing: LETTER_SPACING,
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                px: 0.5,
                mb: '4px',
              }}
            >
              Your layout is ready
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: LABEL_SECONDARY,
                fontSize: SUBTITLE_FONT_SIZE,
                letterSpacing: LETTER_SPACING,
                lineHeight: 1.4,
                textAlign: 'center',
                mb: '20px',
                ...externalFlowLineClamp3Sx,
              }}
            >
              Your floor plan is ready to shuffle and share
            </Typography>

            <Button
              variant="contained"
              size="medium"
              onClick={onOpenGallery}
              disableElevation
              sx={{
                ...externalFlowPrimaryButtonSx,
                whiteSpace: 'nowrap',
              }}
            >
              View furnished layout
            </Button>

            <Box sx={{ flex: 1, minHeight: 0 }} />

            <Typography sx={externalFlowInCardBrandingSx}>
              Powered by MagicFurnish
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default DoneCard;
